import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { WhoIsThisFor } from '../components/WhoIsThisFor';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { MetaPixel } from '../components/MetaPixel';
export function LandingPage() {
  return <>
      <MetaPixel data-id="element-218" />
      <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-indigo-500/30 selection:text-indigo-200" data-id="element-219">
        <Hero data-id="element-220" />
        <ProblemSection data-id="element-221" />
        <SolutionSection data-id="element-222" />
        <ProtocolSection data-id="element-223" />
        <WhoIsThisFor data-id="element-224" />
        <PricingSection data-id="element-225" />
        <Footer data-id="element-226" />
      </div>
    </>;
}